import React, { useEffect, useState } from 'react'
import ContentHeader from '../../../../Components/Layout/ContentHeader'
import Box from '../../../Global/Box'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import {
  REGISTER_USER,
  GET_USERS,
  UPDATE_USER,
  GET_USER_BY_ID,
  UPDATE_ROL_USER_PERMISSIONS,
} from '../../../../graphql/Catalog/Users/user'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useHistory, useParams } from 'react-router'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import {
  validationSchemaUser,
  validationSchemaUserUpdate,
  validationSchemaUserUpdatePassword,
} from '../../../Helpers/validatorCustomerForm'
import InputController from '../../../Global/InputController'
import { objNameRoles } from '../../../../const/constRoles'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { GET_ROLES } from '../../../../graphql/Catalog/Roles/roles'
import { GET_ALL_JURISDICTIONS_AND_SUBS } from '../../../../graphql/Catalog/Jurisdictions/jurisdictions'
import { GET_ALL_GROUPS } from '../../../../graphql/Catalog/Groups/groups'
import {
  GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_2,
  GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3,
} from '../../../../graphql/Catalog/Groups/groupsCategories'
import { GET_ALL_PROVIDERS } from '../../../../graphql/Catalog/Providers/providers'
import { set } from 'lodash'
import {
  GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID,
  GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID,
} from '../../../../graphql/Catalog/Groups/groupsCategoriesSubs'
import { GET_ALL_JOB_POSITIONS } from '../../../../graphql/Catalog/JobPositions/jobPositions'
import { GET_ALL_PROCESSES_CATEGORIES } from '../../../../graphql/Catalog/Processes/ProcessesCategories'
import { GET_PROCESSES_SUBCATEGORIES_BY_PROCESS_CATEGORY_ID } from '../../../../graphql/Catalog/Processes/ProcessesSubCategories'

const Register = () => {
  const { id: _id, show } = useParams()
  const { showLoading, hideLoading } = useLoading()

  //----------- Hooks to save data ------------
  const [schemaValidator, setSchemaValidator] = useState(validationSchemaUser)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [roles, setRoles] = useState([])
  const [varsJurisdiction, setVarsJurisdiction] = useState({
    isJurisdiccionVisible: false,
    jurisdiccionSelected: '',
    jurisdictions: [],
    isSubJurisdiccionVisible: false,
    subJurisdiccionSelected: '',
    subJurisdictions: [],
  })

  const [varsProcesses, setVarsProcesses] = useState({
    isCategoryVisible: false,
    categorySelected: '',
    isSubCategoryVisible: false,
    subCategorySelected: '',
    subCategories: [],
  })

  const [varsGroups, setVarsGroups] = useState({
    isGroupCategoryVisible: false,
    groupCategorySelected: '',
    isGroupCategorySubVisible: false,
    groupCategorySubSelected: '',
    groupCategorySubs: [],
  })

  const [dataOne, setDataOne] = useState(null)
  const [previewPic, setPreviewPic] = useState(null)
  const [_password, set_Password] = useState('1')
  const [groups, setGroups] = useState([])
  const [processesCategories, setProcessesCategories] = useState([])
  const [providersOptions, setProvidersOptions] = useState([])
  const [jobPositions, setJobPositions] = useState([])
  const [selectedRol, setSelectedRol] = useState('')
  const [rolOrigin, setRolOrigin] = useState(null)

  //------------ Queries and Mutations ------------
  const [registerUser] = useMutation(REGISTER_USER, {
    refetchQueries: [
      {
        query: GET_USERS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const [updateUser] = useMutation(UPDATE_USER, {
    refetchQueries: [
      {
        query: GET_USERS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      {
        query: GET_USER_BY_ID,
        variables: {
          getUserByIdId: parseInt(_id),
        },
      },
    ],
  })

  const [updateRolUserPermissions] = useMutation(UPDATE_ROL_USER_PERMISSIONS)

  const [GetGroupsCategoriesSubs] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID
  )

  const [GetProcessesSubCategories] = useMutation(
    GET_PROCESSES_SUBCATEGORIES_BY_PROCESS_CATEGORY_ID
  )

  const [GetGroupsCategoriesSubsByArrayCategoryId] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID
  )

  const {
    data: dataOneUser,
    loading: loadingOneUser,
    error: errorOneUser,
  } = useQuery(GET_USER_BY_ID, {
    variables: {
      getUserByIdId: parseInt(_id),
    },
  })

  const {
    data: dataRoles,
    loading: loadingRoles,
    error: errorRoles,
  } = useQuery(GET_ROLES, { fetchPolicy: 'no-cache' })

  const {
    data: dataJurisdictionsAndSubs,
    loading: loadingJurisdictionsAndSubs,
    error: errorJurisdictionsAndSubs,
  } = useQuery(GET_ALL_JURISDICTIONS_AND_SUBS, { fetchPolicy: 'no-cache' })

  const {
    data: dataGroups,
    loading: loadingGroups,
    error: errorGroups,
  } = useQuery(GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3, {
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataProcessesCategory,
    loading: loadingProcessesCategory,
    error: errorProcessesCategory,
  } = useQuery(GET_ALL_PROCESSES_CATEGORIES, {
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataJob,
    loading: loadingJob,
    error: errorJob,
  } = useQuery(GET_ALL_JOB_POSITIONS)

  const [
    getProviders,
    {
      data: dataProviders,
      loading: loadingProviders,
      error: errorProviders,
      called: calledProviders,
    },
  ] = useLazyQuery(GET_ALL_PROVIDERS, {
    variables: {},
    fetchPolicy: 'no-cache',
  })

  const {
    watch,
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schemaValidator),
  })

  const processData = async (data) => {
    const jurisdiction_id = data?.jurisdiction_id
    const array_sub_jurisdiction = data?.array_sub_jurisdiction
    const array_group_category = data?.array_group_category
    const array_group_category_sub = data?.array_group_category_sub

    const array_processes_category = data?.array_processes_category
    const array_processes_category_sub = data?.array_processes_category_sub

    setSelectedRol(data.id_role)

    let group_category_id = ''
    let processes_category_id = ''

    if (data.id_role === objNameRoles.gestor_interno) {
      let subJurisdictions = []
      if (jurisdiction_id) {
        const findJurisdiction = varsJurisdiction.jurisdictions.find((item) => {
          if (item.value === jurisdiction_id) return true
          return false
        })
        if (findJurisdiction) subJurisdictions = findJurisdiction.subs
      }

      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: true,
        jurisdiccionSelected: jurisdiction_id ? `${jurisdiction_id}` : '',
        isSubJurisdiccionVisible: true,
        subJurisdiccionSelected:
          array_sub_jurisdiction.length > 0 ? array_sub_jurisdiction : '',
        subJurisdictions,
      }))

      handleChangeCategoryGroup(
        { value: array_group_category[0]?.value },
        data.id_role,
        array_group_category_sub
      )

      group_category_id = array_group_category[0]
    } else if (data.id_role === objNameRoles.gestor_global_independiente) {
      let subJurisdictions = []
      if (jurisdiction_id) {
        const findJurisdiction = varsJurisdiction.jurisdictions.find((item) => {
          if (item.value === jurisdiction_id) return true
          return false
        })
        if (findJurisdiction) subJurisdictions = findJurisdiction.subs
      }

      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: true,
        jurisdiccionSelected: jurisdiction_id ? `${jurisdiction_id}` : '',
        isSubJurisdiccionVisible: true,
        subJurisdiccionSelected:
          array_sub_jurisdiction.length > 0 ? array_sub_jurisdiction : '',
        subJurisdictions,
      }))
      handleChangeCategoryGroup(
        array_group_category,
        data.id_role,
        array_group_category_sub
      )

      group_category_id = array_group_category[0]
    } else if (data?.id_role === objNameRoles.gestor_global) {
      let subJurisdictions = []
      if (jurisdiction_id) {
        const findJurisdiction = varsJurisdiction.jurisdictions.find((item) => {
          if (item.value === jurisdiction_id) return true
          return false
        })
        if (findJurisdiction) subJurisdictions = findJurisdiction.subs
      }

      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: true,
        jurisdiccionSelected: jurisdiction_id ? `${jurisdiction_id}` : '',
        isSubJurisdiccionVisible: true,
        subJurisdiccionSelected:
          array_sub_jurisdiction.length > 0 ? array_sub_jurisdiction : '',
        subJurisdictions,
      }))
      handleChangeCategoryGroup(
        array_group_category,
        data.id_role,
        array_group_category_sub
      )

      group_category_id = array_group_category
    } else if (
      data?.id_role === objNameRoles.gestor_tramites ||
      data?.id_role === objNameRoles.revisor_tramites ||
      data?.id_role === objNameRoles.seguimiento_tramites ||
      data?.id_role === objNameRoles.notificador_tramites
    ) {
      handleChangeProcessesCategory(
        array_processes_category,
        data.id_role,
        array_processes_category_sub,
        false,
        true
      )
      processes_category_id = array_processes_category[0]?.value
    }

    const dataFormated = {
      name: data.name,
      username: data.username ?? '',
      first_name: data.first_name,
      last_name: data.last_name,
      userEmail: data.email,
      userPhone: data.phone,
      userRole: data.id_role,
      jurisdiction_id: `${jurisdiction_id}`,
      sub_jurisdiction_id:
        array_sub_jurisdiction.length > 0 ? array_sub_jurisdiction : '',
      avatar: data?.avatarUrl,
      charge: data.charge ?? '', // Add charge to formatted data
      group_category_id:
        data?.id_role === objNameRoles.gestor_global
          ? group_category_id
          : `${group_category_id}`, // Add group_category_id to formatted data
      group_category_sub_id:
        array_group_category_sub.length > 0 ? array_group_category_sub : '', // Add group_category_sub_id to formatted data
      provider_id: data.provider_id ? `${data.provider_id}` : '', // Add provider_id to formatted data

      processes_category_id:
        data?.id_role === objNameRoles.gestor_tramites
          ? processes_category_id
          : `${processes_category_id}`,
      processes_subcategory_id:
        array_processes_category_sub.length > 0
          ? array_processes_category_sub
          : '',
    }

    reset(dataFormated)

    setRolOrigin(data.id_role)

    await getProviders()
  }

  //----------- UseEffect ------------
  useEffect(() => {
    if (_id) {
      setSchemaValidator(validationSchemaUserUpdate)
      if (!loadingOneUser) {
        if (errorOneUser)
          return toastSweetAlert({
            mode: 'error',
            message: errorOneUser.message,
          })

        if (dataOneUser?.GetUserById) {
          setPreviewPic(dataOneUser?.GetUserById?.avatarUrl)
          setDataOne(dataOneUser.GetUserById)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataOneUser, errorOneUser])

  useEffect(() => {
    if (_id && dataOne && varsJurisdiction.jurisdictions.length > 0) {
      processData(dataOne)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataOne, varsJurisdiction.jurisdictions])

  useEffect(() => {
    if (_id && !show) setSchemaValidator(validationSchemaUserUpdate)
    else setSchemaValidator(validationSchemaUser)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!loadingRoles && !loadingJob) {
      const list = dataRoles?.getAllRoles.rows.map((role) => {
        return { label: role.role_name, value: role.id }
      })

      const listJob = dataJob?.getAllJobPositions.rows.map((job) => {
        return { label: job.name, value: job.id }
      })

      setRoles(list)
      setJobPositions(listJob)
    }
  }, [loadingRoles, dataRoles, errorRoles, dataJob, loadingJob, errorJob])

  useEffect(() => {
    if (!loadingJurisdictionsAndSubs) {
      const list = dataJurisdictionsAndSubs?.getAllJurisdictionsAndSubs.map(
        (jurisdiction) => {
          const subs = jurisdiction.SubsOfJurisdiction.map((sub) => ({
            value: sub.id,
            label: sub.name,
          }))

          return {
            value: jurisdiction.id,
            label: jurisdiction.name,
            subs,
          }
        }
      )
      setVarsJurisdiction((old) => ({ ...old, jurisdictions: list }))
    }
  }, [
    loadingJurisdictionsAndSubs,
    dataJurisdictionsAndSubs,
    errorJurisdictionsAndSubs,
  ])

  useEffect(() => {
    if (!loadingGroups) {
      const list = dataGroups?.getAllGroupsCategoriesAndSubsByGroupIdQuery.map(
        (group) => {
          return { label: group.name, value: group.id }
        }
      )
      setGroups(list)
    }
  }, [loadingGroups, dataGroups, errorGroups])

  useEffect(() => {
    if (!loadingProcessesCategory) {
      const list = dataProcessesCategory?.getAllProcessesCategories?.rows?.map(
        (category) => {
          return { label: category.name, value: category.id }
        }
      )
      setProcessesCategories(list)
    }
  }, [dataProcessesCategory, loadingProcessesCategory, errorProcessesCategory])

  const watchPassword = watch('password')
  const watchUserRole = watch('userRole')

  useEffect(() => {
    if (_id) {
      if (watchPassword === undefined || watchPassword === '') {
        setSchemaValidator(validationSchemaUserUpdate)
        set_Password('1')
      } else {
        setSchemaValidator(validationSchemaUserUpdatePassword)
        set_Password(getValues('password'))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, watchPassword])

  useEffect(() => {
    if (calledProviders) {
      if (!loadingProviders) {
        const list = dataProviders?.getAllProviders.rows.map((provider) => {
          return {
            value: provider.id,
            label: `${provider.card_name} - ${provider.rfc}`,
          }
        })
        setProvidersOptions(list)
      }
    }
  }, [loadingProviders, dataProviders, errorProviders, calledProviders])

  //-------- Functions -----------
  const handleChangeCategoryGroup = async (
    selected,
    userRole,
    groupCategorySubSelected,
    groupCategorySelected
  ) => {
    try {
      if (
        userRole === objNameRoles.gestor_global ||
        userRole === objNameRoles.gestor_global_independiente
      ) {
        let groupCategorySubMapped = []
        //WHEN THE USER IS A GLOBAL MANAGER AND GLOBAL INDEPENDENT MANAGER
        //CAN SELECT MULTIPLE CATEGORIES AND SUBCATEGORIES - THIS IS A CHANGE
        const groupCategorySelected = selected?.map((item) => item.value)

        const { data } = await GetGroupsCategoriesSubsByArrayCategoryId({
          variables: {
            array_group_category_id: groupCategorySelected,
          },
          fetchPolicy: 'no-cache',
        })

        const optionsSubs = data.getAllGroupsCategoriesSubByArrayCategoryId.map(
          (item) => {
            return {
              value: item.id,
              label: item.name,
              group_category_id: item.group_category_id,
            }
          }
        )
        if (groupCategorySubSelected) {
          //FILTER THE SUBCATEGORIES THAT BELONG TO THE SELECTED CATEGORIES
          const filteredOptions = groupCategorySubSelected.map((item) => {
            const findCategory = optionsSubs.find(
              (sub) => sub.value === item.value
            )
            if (findCategory) {
              groupCategorySubMapped.push({
                value: item.value,
                label: item.label,
                group_category_id: findCategory.group_category_id,
              })
            }
          })
        }

        setVarsGroups((old) => ({
          ...old,
          groupCategorySelected: selected,
          isGroupCategoryVisible: true,
          isGroupCategorySubVisible: true,
          groupCategorySubSelected: groupCategorySubSelected
            ? groupCategorySubMapped
            : '',
          groupCategorySubs: optionsSubs,
        }))
        setValue('group_category_id', selected)
        return
      }

      //Fill the group category sub
      const { value } = selected

      const { data } = await GetGroupsCategoriesSubs({
        variables: { getAllGroupsCategoriesSubByCategoryIdId: value },
      })

      let groupCategorySubs = data?.getAllGroupsCategoriesSubByCategoryId?.map(
        (item) => {
          return { value: item.id, label: item.name }
        }
      )

      setVarsGroups((old) => ({
        ...old,
        groupCategorySelected: value,
        isGroupCategorySubVisible: true,
        isGroupCategoryVisible: true,
        groupCategorySubSelected: groupCategorySubSelected
          ? groupCategorySubSelected
          : '',
        groupCategorySubs,
      }))
      setValue('group_category_id', value)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  useEffect(() => {
    if (
      (getValues('userRole') === objNameRoles.gestor_tramites ||
        getValues('userRole') === objNameRoles.revisor_tramites ||
        getValues('userRole') === objNameRoles.seguimiento_tramites ||
        getValues('userRole') === objNameRoles.notificador_tramites) &&
      varsProcesses?.subCategorySelected
    ) {
      //Delete SubcategoriesSelected that no have subCategories
      let newSubCategorySelected = varsProcesses?.subCategorySelected.filter(
        (item) =>
          varsProcesses?.subCategories.some((sub) => sub.value === item.value)
      )
      setVarsProcesses((old) => ({
        ...old,
        subCategorySelected:
          newSubCategorySelected.length > 0 ? newSubCategorySelected : [],
      }))
      setValue(
        'processes_subcategory_id',
        newSubCategorySelected.length > 0 ? newSubCategorySelected : []
      )
    }
  }, [varsProcesses.subCategories])

  const handleChangeProcessesCategory = async (
    selected,
    userRole,
    subCategorySelectedProp,
    useVarProcessesSubCat,
    fromUpdate
  ) => {
    try {
      let subCategories = []
      let value = null
      if (
        userRole === objNameRoles.gestor_tramites ||
        userRole === objNameRoles.revisor_tramites ||
        userRole === objNameRoles.seguimiento_tramites ||
        userRole === objNameRoles.notificador_tramites
      ) {
        //Multiple
        if (selected.length > 0) {
          value = selected
          let categoryIds = selected.map((item) => item.value)
          for (const categoryId of categoryIds) {
            //Delete
            const { data } = await GetProcessesSubCategories({
              variables: { processCategoryId: categoryId },
            })

            data?.getProcessesSubCategoriesByProcessCategoryId?.map((item) => {
              subCategories.push({
                value: item.id,
                label: item.name,
                category_id: categoryId,
              })
            })
          }
        }
      } else {
        //Fill the processes_subcategories
        const { value: valueSelected } = selected
        value = valueSelected
        if (valueSelected) {
          const { data } = await GetProcessesSubCategories({
            variables: { processCategoryId: valueSelected },
          })

          subCategories =
            data?.getProcessesSubCategoriesByProcessCategoryId?.map((item) => {
              return {
                value: item.id,
                label: item.name,
                category_id: valueSelected,
              }
            })
        }
      }

      let newProcessesCategorySub = []
      if (fromUpdate && subCategorySelectedProp.length > 0) {
        //If the user is being updated, we need to set the subcategories selected
        //that belong to the selected categories
        subCategorySelectedProp.map((item) => {
          const findCategory = subCategories.find(
            (sub) => sub.value === item.value
          )
          if (findCategory) {
            newProcessesCategorySub.push({
              value: item.value,
              label: item.label,
              category_id: findCategory.category_id,
            })
          }
        })
      }

      setVarsProcesses((old) => ({
        ...old,
        categorySelected: value,
        isSubCategoryVisible: true,
        subCategories,
        ...(!useVarProcessesSubCat && {
          subCategorySelected: fromUpdate
            ? newProcessesCategorySub
            : subCategorySelectedProp || '',
        }),
        ...(subCategorySelectedProp && {
          isCategoryVisible: true,
        }),
      }))
      setValue('processes_category_id', value)
      if (!subCategorySelectedProp && !useVarProcessesSubCat)
        setValue('processes_subcategory_id', null)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleChangeRole = async (selected) => {
    setSelectedRol(selected.value)

    if (selected.value === objNameRoles.gestor_global) {
      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: true,
        jurisdiccionSelected: '',
        isSubJurisdiccionVisible: true,
        subJurisdiccionSelected: '',
        subJurisdictions: [],
        isGroupCategoryVisible: true,
        isGroupCategorySubVisible: false,
      }))
      setVarsGroups((old) => ({
        ...old,
        isGroupCategoryVisible: true,
        isGroupCategorySubVisible: true,
        groupCategorySelected: '',
        groupCategorySubSelected: '',
        groupCategorySubs: [],
      }))
      setVarsProcesses((old) => ({
        ...old,
        isCategoryVisible: false,
        isSubCategoryVisible: false,
        categorySelected: '',
        subCategorySelected: '',
        subCategories: [],
      }))
      setValue('sub_jurisdiction_id', null)
      setValue('group_category_id', null)
      setValue('group_category_sub_id', null)
      setValue('provider_id', null)
      setValue('processes_category_id', null)
      setValue('processes_subcategory_id', null)
      return
    } else if (selected.value === objNameRoles.gestor_interno) {
      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: true,
        jurisdiccionSelected: '',
        isSubJurisdiccionVisible: true,
        subJurisdiccionSelected: '',
        subJurisdictions: [],
        isGroupCategoryVisible: true,
        isGroupCategorySubVisible: false,
      }))
      setVarsGroups((old) => ({
        ...old,
        isGroupCategoryVisible: true,
        groupCategorySelected: '',
        isGroupCategorySubVisible: false,
        groupCategorySubSelected: '',
        groupCategorySubs: [],
      }))
      setVarsProcesses((old) => ({
        ...old,
        isCategoryVisible: false,
        isSubCategoryVisible: false,
        categorySelected: '',
        subCategorySelected: '',
        subCategories: [],
      }))
      setValue('sub_jurisdiction_id', null)
      setValue('group_category_id', null)
      setValue('group_category_sub_id', null)
      setValue('provider_id', null)
      setValue('processes_category_id', null)
      setValue('processes_subcategory_id', null)
      return
    } else if (selected.value === objNameRoles.gestor_global_independiente) {
      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: true,
        jurisdiccionSelected: '',
        isSubJurisdiccionVisible: true,
        subJurisdiccionSelected: '',
        subJurisdictions: [],
        isGroupCategoryVisible: true,
        isGroupCategorySubVisible: false,
      }))
      setVarsGroups((old) => ({
        ...old,
        isGroupCategoryVisible: true,
        groupCategorySelected: '',
        isGroupCategorySubVisible: true,
        groupCategorySubSelected: '',
        groupCategorySubs: [],
      }))
      setVarsProcesses((old) => ({
        ...old,
        isCategoryVisible: false,
        isSubCategoryVisible: false,
        categorySelected: '',
        subCategorySelected: '',
        subCategories: [],
      }))

      setValue('sub_jurisdiction_id', null)
      setValue('group_category_id', null)
      setValue('group_category_sub_id', null)
      setValue('provider_id', null)
      setValue('processes_category_id', null)
      setValue('processes_subcategory_id', null)
      return
    } else if (
      selected.value === objNameRoles.provedor_pipas ||
      selected.value === objNameRoles.chofer_pipas
    ) {
      setVarsJurisdiction((old) => ({
        ...old,
        isJurisdiccionVisible: false,
        jurisdiccionSelected: '',
        isSubJurisdiccionVisible: false,
        subJurisdiccionSelected: '',
        subJurisdictions: [],
      }))
      setVarsProcesses((old) => ({
        ...old,
        isCategoryVisible: false,
        isSubCategoryVisible: false,
        categorySelected: '',
        subCategorySelected: '',
        subCategories: [],
      }))
      setValue('processes_category_id', null)
      setValue('processes_subcategory_id', null)

      setValue('sub_jurisdiction_id', null)

      return await getProviders()
    }

    //Processes category and subcategory
    if (
      selected.value === objNameRoles.gestor_tramites ||
      selected.value === objNameRoles.revisor_tramites ||
      selected.value === objNameRoles.seguimiento_tramites ||
      selected.value === objNameRoles.notificador_tramites
    ) {
      setVarsProcesses((old) => ({
        ...old,
        isCategoryVisible: true,
        isSubCategoryVisible: false,
        categorySelected: '',
        subCategorySelected: '',
        subCategories: [],
      }))
      setValue('group_category_id', null)
      setValue('group_category_sub_id', null)
      setValue('provider_id', null)
      setValue('processes_category_id', null)
      setValue('processes_subcategory_id', null)
      return
    }

    setVarsJurisdiction((old) => ({
      ...old,
      isJurisdiccionVisible: false,
      jurisdiccionSelected: '',
      isSubJurisdiccionVisible: false,
      subJurisdiccionSelected: '',
      subJurisdictions: [],
    }))

    setVarsProcesses((old) => ({
      ...old,
      isCategoryVisible: false,
      isSubCategoryVisible: false,
      categorySelected: '',
      subCategorySelected: '',
      subCategories: [],
    }))

    setValue('group_category_id', null)
    setValue('group_category_sub_id', null)
    setValue('provider_id', null)
    setValue('processes_category_id', null)
    setValue('processes_subcategory_id', null)
  }

  const handleChangeJurisdiction = (selected) => {
    setVarsJurisdiction((old) => ({
      ...old,
      jurisdiccionSelected: selected.value,
      subJurisdiccionSelected: '',
      subJurisdictions: selected.subs,
    }))
  }

  const handleSave = async (Data) => {
    const id_role = parseInt(Data.userRole)
    const { jurisdiccionSelected, subJurisdiccionSelected } = varsJurisdiction
    let jurisdiction_id = null
    let array_sub_jurisdiction = null

    if (
      [
        objNameRoles.gestor_global,
        objNameRoles.gestor_interno,
        objNameRoles.gestor_global_independiente,
      ].includes(id_role)
    ) {
      if (jurisdiccionSelected === '' || !jurisdiccionSelected) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere la jurisdiccion',
        })
      }
      jurisdiction_id = parseInt(jurisdiccionSelected)

      if (
        !subJurisdiccionSelected ||
        subJurisdiccionSelected === '' ||
        subJurisdiccionSelected.length === 0
      ) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere la zona(s)',
        })
      }

      let arraySubJurisdiccion = []
      subJurisdiccionSelected.map((item) =>
        arraySubJurisdiccion.push(parseInt(item.value))
      )
      array_sub_jurisdiction = arraySubJurisdiccion
    }

    let provider_id = null
    if (
      id_role === objNameRoles.provedor_pipas ||
      id_role === objNameRoles.chofer_pipas
    ) {
      if (!Data.provider_id) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere el proveedor',
        })
      }

      provider_id = parseInt(Data.provider_id)
    }

    if (!Data.charge || Data.charge == 0)
      return toastSweetAlert({
        mode: 'error',
        message: 'El campo puesto es requerido',
      })

    let input = {
      email: Data.userEmail,
      name: Data.name,
      first_name: Data?.first_name,
      last_name: Data?.last_name,
      phone: String(Data.userPhone),
      id_role,
      jurisdiction_id,
      array_sub_jurisdiction,
      provider_id,
      charge: parseInt(Data.charge),
      username: Data.username,
    }

    //validaciones para rol "gestor global" y seteo de data input
    if (id_role === objNameRoles.gestor_global) {
      if (varsGroups.groupCategorySelected.length === 0) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere la categoria',
        })
      }

      input.array_group_category_id = varsGroups.groupCategorySelected.map(
        (item) => parseInt(item.value)
      )

      input.array_group_category_sub_id =
        varsGroups.groupCategorySubSelected.map((item) => parseInt(item.value))

      const groupCategoryWithSubs = varsGroups.groupCategorySelected.map(
        (item) => {
          const filterSubs = varsGroups.groupCategorySubSelected.filter(
            (sub) => sub.group_category_id === item.value
          )

          return {
            group_category_id: +item.value,
            group_category_sub_id: filterSubs.map((sub) => +sub.value),
          }
        }
      )

      input.array_groups_categories = groupCategoryWithSubs
    }

    //validaciones para rol "gestor interno" y seteo de data input
    if (id_role === objNameRoles.gestor_interno) {
      if (
        !varsGroups.groupCategorySelected ||
        varsGroups.groupCategorySubSelected.length === 0
      ) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere la categoria y subcategoria',
        })
      }

      input.array_group_category_id = [
        parseInt(varsGroups.groupCategorySelected),
      ]
      input.array_group_category_sub_id =
        varsGroups.groupCategorySubSelected.map((item) => parseInt(item.value))
    }

    //validaciones para rol "gestor global independiente" y seteo de data input
    if (id_role === objNameRoles.gestor_global_independiente) {
      if (
        !varsGroups.groupCategorySelected ||
        varsGroups.groupCategorySubSelected.length === 0
      ) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere la categoria y subcategoria',
        })
      }

      input.array_group_category_id = varsGroups.groupCategorySelected.map(
        (item) => parseInt(item.value)
      )
      input.array_group_category_sub_id =
        varsGroups.groupCategorySubSelected.map((item) => parseInt(item.value))

      const groupCategoryWithSubs = varsGroups.groupCategorySelected.map(
        (item) => {
          const filterSubs = varsGroups.groupCategorySubSelected.filter(
            (sub) => sub.group_category_id === item.value
          )

          return {
            group_category_id: +item.value,
            group_category_sub_id: filterSubs.map((sub) => +sub.value),
          }
        }
      )

      input.array_groups_categories = groupCategoryWithSubs
    }

    //Processes category and subcategory
    if (
      id_role === objNameRoles.gestor_tramites ||
      id_role === objNameRoles.revisor_tramites ||
      id_role === objNameRoles.seguimiento_tramites ||
      id_role === objNameRoles.notificador_tramites
    ) {
      if (
        !varsProcesses.categorySelected ||
        varsProcesses.categorySelected.length === 0 ||
        !varsProcesses.subCategorySelected ||
        varsProcesses.subCategorySelected.length === 0
      ) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Para este Rol se requiere la categoria de trámites',
        })
      }

      let arrayProcesses = []
      let errorFlag = {
        error: false,
        message: '',
      }
      varsProcesses?.categorySelected?.map((category) => {
        if (!errorFlag.error) {
          let arraySubCategory = []
          //Find the subcategories that belong to the category
          arraySubCategory = varsProcesses?.subCategorySelected?.filter(
            (sub) => sub.category_id === category.value
          )
          if (arraySubCategory.length === 0)
            errorFlag = {
              error: true,
              message: `No hay subcategorías para la categoría ${category.label}`,
            }

          arraySubCategory = arraySubCategory.map((item) =>
            parseInt(item.value)
          )

          arrayProcesses.push({
            category_id: category.value,
            category_sub_ids: arraySubCategory,
          })
        }
      })

      input.processes = arrayProcesses

      if (errorFlag.error)
        return toastSweetAlert({
          mode: 'error',
          message: errorFlag.message,
        })
    }

    setLoading(true)
    showLoading()
    try {
      if (_id) {
        input.password = _password

        let message = 'Usuario ha sido actualizado con éxito'

        await updateUser({
          variables: {
            userId: parseInt(_id),
            input,
            avatarFile:
              typeof getValues('avatar') === 'object'
                ? getValues('avatar')
                : null,
          },
        })

        if (Data.userRole !== rolOrigin) {
          const isUpdateRol = await updateRolUserPermissions({
            variables: {
              id_user: parseInt(_id),
              id_role: parseInt(Data.userRole),
            },
          })

          if (isUpdateRol?.data?.updateRolUserAndPermissions === true) {
            message += ' y rol cambiado con éxito'
          }
        }

        return (
          toastSweetAlert({ mode: 'ok', message }),
          history.push(`/catalog/users`)
        )
      } else {
        input.password = Data.password

        await registerUser({
          variables: { input, avatarFile: getValues('avatar') },
        })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'El usuario ha sido registrado correctamente',
          },
          history.push(`/catalog/users`)
        )
      }
    } catch (error) {
      setLoading(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title="Control de usuario"
        breadcrumb="Usuarios"
        windowTitle={`${_id ? 'Editar' : 'Agregar nuevo'} usuario `}
      />
      <FormProvider {...methods}>
        <form className="px-3 pb-3" onSubmit={handleSubmit(handleSave)}>
          <Box
            title={`${
              _id ? (show ? 'Detalles' : 'Editar') : 'Agregar nuevo'
            } usuario`}
            btnRedPath="/catalog/users"
            btnRedTxt="Cancelar"
            btnSubmit={!show}
            btnState={loading}
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-lg-12 col-md-12 col-sm-12">
                    <InputController
                      disabled={show}
                      label="Avatar"
                      inputType="image"
                      name="avatar"
                      previewPic={previewPic}
                      validateFormat="imageAvatar"
                      validateFormatMsg="Solo se admite JPG, JPGE y PNG"
                      // formatAccept=".jpg .png .jpge"
                      control={control}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Correo electrónico"
                      type="text"
                      name="userEmail"
                      placeholder="Ingrese un correo electrónico"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Num. Empleado"
                      type="text"
                      name="username"
                      placeholder="Ingrese Num. Empleado"
                      control={control}
                      disabled={show}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Nombre"
                      type="text"
                      name="name"
                      placeholder="Ingrese un nombre"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Apellido paterno"
                      type="text"
                      name="first_name"
                      placeholder="Ingrese un apellido paterno"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Apellido materno"
                      type="text"
                      name="last_name"
                      placeholder="Ingrese un apellido materno"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Teléfono"
                      inputType="text"
                      name="userPhone"
                      placeholder="Ingrese un teléfono"
                      control={control}
                      disabled={show}
                      maxLength={10}
                    />
                  </div>
                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Rol"
                      type="text"
                      name="userRole"
                      inputType="choosen"
                      options={roles}
                      control={control}
                      changeAction={(e) => handleChangeRole(e)}
                      disabled={show}
                    />
                  </div>

                  {(watchUserRole === objNameRoles.provedor_pipas ||
                    watchUserRole === objNameRoles.chofer_pipas) && (
                    <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                      <InputController
                        label="Proveedor"
                        type="text"
                        name="provider_id"
                        inputType="choosen"
                        options={
                          providersOptions.length > 0 ? providersOptions : null
                        }
                        control={control}
                        disabled={show}
                        placeholderTxt="Selecciona un proveedor"
                      />
                    </div>
                  )}

                  <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                    <InputController
                      label="Puesto"
                      type="text"
                      name="charge"
                      inputType="choosen"
                      options={jobPositions}
                      placeholder="Selecciona un puesto"
                      control={control}
                      disabled={show}
                    />
                  </div>

                  {varsJurisdiction.isJurisdiccionVisible && (
                    <>
                      <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                        <InputController
                          label="Jurisdiccion"
                          type="text"
                          name="jurisdiction_id"
                          inputType="choosen"
                          options={varsJurisdiction.jurisdictions}
                          control={control}
                          changeAction={(e) => handleChangeJurisdiction(e)}
                          valueManual={varsJurisdiction.jurisdiccionSelected}
                          disabled={show}
                          placeholderTxt="Selecciona una"
                        />
                      </div>
                      {varsJurisdiction.isSubJurisdiccionVisible && (
                        <>
                          <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                            <InputController
                              label="Zona(s)"
                              type="text"
                              name="sub_jurisdiction_id"
                              inputType="choosen"
                              options={varsJurisdiction.subJurisdictions}
                              control={control}
                              changeAction={(e) =>
                                setVarsJurisdiction((old) => ({
                                  ...old,
                                  subJurisdiccionSelected: e,
                                }))
                              }
                              disabled={show}
                              value={varsJurisdiction.subJurisdiccionSelected}
                              isMulti
                              closeMenuOnSelect={false}
                              choosenOptions
                              placeholderTxt={
                                !varsJurisdiction.jurisdiccionSelected
                                  ? 'Elige primero la jurisdiccion'
                                  : 'Elige una o varias zonas'
                              }
                            />
                          </div>
                        </>
                      )}
                      {/**--------- SHOW GROUPS */}
                      {varsGroups.isGroupCategoryVisible && (
                        <div className="row col-12">
                          <div
                            className={`mb-3 col-md-6 col-sm-6 
                              ${
                                ''
                                // selectedRol === objNameRoles.gestor_global
                                //   ? 'col-md-12'
                                //   : ''
                              }
                                `}
                          >
                            <InputController
                              label={`${
                                selectedRol === objNameRoles.gestor_global
                                  ? 'Categoría(s) de Grupo'
                                  : 'Categoría de Grupo'
                              }`}
                              name="group_category_id"
                              inputType="choosen"
                              options={groups}
                              control={control}
                              rules={{ required: true }}
                              disabled={show}
                              isMulti={
                                selectedRol === objNameRoles.gestor_global ||
                                selectedRol ===
                                  objNameRoles.gestor_global_independiente
                              }
                              closeMenuOnSelect={false}
                              choosenOptions
                              changeAction={(e) =>
                                handleChangeCategoryGroup(
                                  e,
                                  getValues('userRole'),
                                  varsGroups.groupCategorySubSelected,
                                  varsGroups.groupCategorySelected
                                )
                              }
                              value={varsGroups.groupCategorySelected}
                              autoComplete="off"
                            />
                          </div>
                          {varsGroups.isGroupCategorySubVisible && (
                            <div className="mb-3 col-md-6 col-sm-12">
                              <InputController
                                label="SubCategoría(s) de Categoría"
                                type="text"
                                name="group_category_sub_id"
                                inputType="choosen"
                                options={varsGroups.groupCategorySubs}
                                control={control}
                                changeAction={(e) =>
                                  setVarsGroups((old) => ({
                                    ...old,
                                    groupCategorySubSelected: e,
                                  }))
                                }
                                // rules={{ required: true }}
                                disabled={show}
                                value={varsGroups.groupCategorySubSelected}
                                isMulti
                                closeMenuOnSelect={false}
                                choosenOptions
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}

                  {/**--------- SHOW PROCESSESS CATEGORIES */}
                  {varsProcesses?.isCategoryVisible && (
                    <div className="row col-12">
                      <div className={`mb-3 col-md-6 col-sm-12`}>
                        <InputController
                          label={`${
                            selectedRol !== objNameRoles.gestor_tramites &&
                            selectedRol !== objNameRoles.revisor_tramites &&
                            selectedRol !== objNameRoles.seguimiento_tramites &&
                            selectedRol !== objNameRoles.notificador_tramites
                              ? 'Categoría'
                              : 'Categoría(s)'
                          }`}
                          name="processes_category_id"
                          inputType="choosen"
                          options={processesCategories}
                          control={control}
                          rules={{ required: true }}
                          disabled={show}
                          isMulti={
                            selectedRol === objNameRoles.gestor_tramites ||
                            selectedRol === objNameRoles.revisor_tramites ||
                            selectedRol === objNameRoles.seguimiento_tramites ||
                            selectedRol === objNameRoles.notificador_tramites
                          }
                          closeMenuOnSelect={false}
                          choosenOptions
                          changeAction={(e) =>
                            handleChangeProcessesCategory(
                              e,
                              getValues('userRole'),
                              null,
                              true
                            )
                          }
                          value={varsProcesses.categorySelected}
                          autoComplete="off"
                        />
                      </div>
                      {varsProcesses.isSubCategoryVisible && (
                        <div className="mb-3 col-md-6 col-sm-12">
                          <InputController
                            label="SubCategoría(s) de Categoría"
                            type="text"
                            name="processes_subcategory_id"
                            inputType="choosen"
                            options={varsProcesses.subCategories}
                            control={control}
                            changeAction={(e) =>
                              setVarsProcesses((old) => ({
                                ...old,
                                subCategorySelected: e,
                              }))
                            }
                            disabled={show}
                            value={varsProcesses.subCategorySelected}
                            isMulti
                            closeMenuOnSelect={false}
                            choosenOptions
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {!show && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                        <InputController
                          label="Contraseña"
                          type="password"
                          name="password"
                          placeholder="Ingrese una contraseña"
                          control={control}
                          disabled={show}
                        />
                      </div>
                      <div className="mb-3 col-lg-4 col-md-6 col-sm-12">
                        <InputController
                          label="Confirmar contraseña"
                          type="password"
                          name="passwordConfirm"
                          placeholder="Confirme la contraseña"
                          control={control}
                          disabled={show}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="pb-4"></div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default Register
